import { render, staticRenderFns } from "./BulletinBoardList.vue?vue&type=template&id=3fb9e86b&scoped=true&"
import script from "./BulletinBoardList.vue?vue&type=script&lang=js&"
export * from "./BulletinBoardList.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoardList.vue?vue&type=style&index=0&id=3fb9e86b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9e86b",
  null
  
)

export default component.exports